/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ControlTable } from "../../../components/Table";
import { getBankAccountSummariesDownloads, getBankAccountSummaryList } from "../../../apis/finances/bank";
import { getDay } from "../../../utils/date";
import Icon from "../../../components/Icon";
import defaultBankImage from "../../../assets/images/bank-card-images/default-bank-img.png";
import Filters from "../../../components/Filters";
import CashAccount from "./CashAccount";
import useForm from "../../../hooks/useForm";
import { getParams } from "../../../utils/params";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import { HashLink as Link } from "react-router-hash-link";
import PageHeader from "../../../components/PageHeader";
import { downExcelFile } from "../../../utils/download";

const CashAccountList = (props) => {
  const { permission, activeTab, tabList } = props;
  const history = useHistory();
  const [fields] = useState([
    {
      title: "계좌",
      key: "name",
      onValue: (value, field, data) => {
        const { name } = data;
        return (
          <>
            <div>
              <Icon
                className="bank-img-wrap"
                src={defaultBankImage}
                alt={name}
              />
              <span className="margin-left-8">{name}</span>
            </div>
          </>
        );
      },
    },
    {
      title: "기초잔액",
      key: "preBalanceAmt",
      type: "comma",
    },
    {
      title: "총 입금액",
      key: "totalInAmt",
      className: "color-red-100",
      type: "comma",
    },
    {
      title: "총 출금액",
      key: "totalOutAmt",
      className: "color-purple-100",
      type: "comma",
    },
    {
      title: "최종 잔액",
      key: "balanceAmt",
      type: "comma",
    },
  ]);
  // 상세 모달
  const [open, setOpen] = useState(false);
  const [bankData, setBankData] = useState({});

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    list,
    setList,
    isLoading,
    setIsLoading,
  } = useForm({
    type: "cash_account",
    range: {
      tradeTime: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date,
    },
  });

  useEffect(() => {
    if (!isEmpty(history.location.state)) {
      setBankData(history.location.state.data);
      setOpen(true);
    }
  }, [history]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  const submit = (params) => {
    setIsLoading(true);
    getBankAccountSummaryList(getParams(params))
      .then((res) => {
        setList(res.data.bankAccountSummaries);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filters = [
    {
      title: "조회기간",
      key: "range.tradeTime",
      type: "customdatepicker",
    },
  ];

  const handleRowClick = (data) => {
    setOpen(true);
    setBankData(data);
  };

  const headerButtons = [
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        //console.log(form)
        const from = form.range.tradeTime[0];
        const to = form.range.tradeTime[1];
        const body = {
          type: form.type,
          range: {
            tradeTime: {
              from,
              to,
            },
          }
        };
        getBankAccountSummariesDownloads(body).then((res) => {
          downExcelFile(res, `기타거래목록${from}~${to}.xlsx`);
        });
      },
    },
  ];

  return (
    <>
      <div className="bank-account-list">
        <PageHeader title={"기타 거래"}
          activeTab={activeTab}
          tabList={!isEmpty(tabList) ? [] : tabList}
          buttons={headerButtons}
        />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isLoading={isLoading}
          fields={fields}
          list={list}
          onSelect={handleRowClick}
          noDataText={
            <Link
              className="text-align-center"
              to="/manager/financial?tab=auto-scrapping#section-four"
            >
              <p className="color-gray-5 nowrap">
                {"관리자 > 금융 정보 자동 수집 > 현금 계좌를 생성해주세요."}
              </p>
              <p className="color-main-80 font-size-15">
                {"클릭시 해당 메뉴로 이동합니다."}
              </p>
            </Link>
          }
        />
      </div>
      <CashAccount
        permission={permission}
        open={open}
        setOpen={setOpen}
        bankData={bankData}
        setBankData={setBankData}
        params={form}
        listSubmit={() => submit(form)}
      />
    </>
  );
};

export default CashAccountList;
